import { actions } from 'common/store/resource';

export const NAMESPACE = 'DEVICE/PING';

const resourceActions = actions.factory(NAMESPACE);

export const {
  LOAD,
  LOAD_SUCCESS,
  LOAD_ERROR,
  CLEAR,
} = resourceActions.TYPES;

export const {
  loadSuccess,
  loadError,
  clear,
} = resourceActions;

export const load = deviceId => ({
  ...resourceActions.load(),
  deviceId,
});
